<template>
    <div class="d-flex flex-column fill-height px-3">

        <div class="">
            <div class="d-flex align-center mb-3">
                <asset-image :src="require('../../images/ai_navigator/ai_navigator_icon.svg')" width="32" class="mr-2">
                </asset-image>

                <h2 class="oxygen">AI Navigator</h2>
            </div>

            <div class="d-flex align-center mb-2">
                <h4 class="text-body-2 font-weight-medium">Location / I-Codes</h4>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon aria-label="Information about jurisdiction selection">
                            <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                    </template>
                    <span class="tooltip-content">Select a US state or "I-Codes" for ICC model code</span>
                </v-tooltip>
            </div>
            <navigator-location-selection/>
        </div>

        <div>
            <div>
                <v-btn block depressed outlined class="grey lighten-4 my-3" @click="newChatClicked">
                    <v-icon class="mr-1">mdi-message-outline</v-icon>
                    New Question
                </v-btn>
            </div>
            <navigator-sidebar-disclaimer-block/>
            <v-divider class="my-4"></v-divider>
            <h5 class="text--secondary px-1">History</h5>
        </div>

        <div class="overflow-auto mx-n3">
            <v-list dense>
                <v-list-item v-for="(item, i) in conversationGroups" :key="i" @click="selectDate(item.createdAt)"
                    :class="{ 'selected': item.createdAt === currentQuestionDate }">
                    <v-list-item-title>{{ formatDate(item.createdAt) }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>

<script>
import AssetImage from "../AssetImage.vue";
import NavigatorTipsBlock from "./blocks/NavigatorTipsBlock.vue";
import NavigatorSidebarDisclaimerBlock from "./blocks/NavigatorSidebarDisclaimerBlock.vue";
import NavigatorLocationSelection from "./blocks/NavigatorLocationSelection.vue";
import DividerExpand from "../expands/DividerExpand.vue";
import { DateUtil } from "../../util/DateUtil";

export default {
    components: {
        DividerExpand,
        NavigatorLocationSelection,
        NavigatorSidebarDisclaimerBlock,
        NavigatorTipsBlock,
        AssetImage,
    },
    emits: ['loadConversations'],
    props: {
        groupedDates: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        conversationGroups() {
            return this.groupedDates || [];
        },
        currentQuestionDate() {
            return this.$store.getters.getAiNavigatorCurrentQuestionDate;
        }
    },
    methods: {
        newChatClicked() {
            this.$store.commit('setAiNavigatorCurrentQuestionDate', null);
        },
        selectDate(questionDate) {
            this.$emit('loadConversations', questionDate);
            this.$store.commit('setAiNavigatorCurrentQuestionDate', questionDate);
        },
        formatDate(date) {
            const dateStr = new Date(date + "T00:00:00").toDateString();
            let md = DateUtil.dateToAbbreviatedMonthAndDay(dateStr);
            if (DateUtil.isToday(dateStr)) {
                return `${md} (Today)`;
            }

            return md;
        }
    }
}
</script>

<style lang="scss" scoped>
.selected {
    background: #E1EBE8;
}
</style>